import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import {
  SCHEDULE_ITEM_TYPES,
  SCHEDULE_TYPES_HUMAN_VALUES,
  SCHEDULE_TYPES
} from 'ducks/tenancy';

import {formatDate} from 'utils/datetime';

import Alert from 'components/Alert';
import Table from 'components/Table';
import PaymentStatusTag from 'components/PaymentStatusTag';
import Money from 'components/Money';
import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

const PaymentRow = ({
  payment,
  handleRowClick,
  redirectToBookingDetail,
  advancedMode
}) => {
  const {paymentDetails} = payment;

  return (
    <Table.Row
      className={classNames('scheduleRow', {
        highlighted: payment.highlighted
      })}
      onClick={() =>
        handleRowClick({
          item: SCHEDULE_ITEM_TYPES.PAYMENT,
          itemId: payment.id,
          scheduleType: SCHEDULE_TYPES[payment.scheduleType],
          tenancyId: paymentDetails.tenancyId
        })
      }>
      <Table.Cell className="booking">
        <ClickIconWithNoPropagation
          onClick={() =>
            redirectToBookingDetail({bookingId: payment.bookingId})
          }>
          <div className="colab-bold">#{payment.bookingId}</div>
        </ClickIconWithNoPropagation>
      </Table.Cell>
      <Table.Cell className="date">{formatDate(payment.date)}</Table.Cell>
      {advancedMode && <Table.Cell className="dueDate" />}
      <Table.Cell className="type">
        <div className="colab-centered-v">
          {paymentDetails.hasXeroErrors && <Alert />}
          <div className="colab-centered-v">Payment</div>
        </div>
      </Table.Cell>
      <Table.Cell className="description">
        {paymentDetails.reference}
      </Table.Cell>
      <Table.Cell className="category">
        {_.get(SCHEDULE_TYPES_HUMAN_VALUES, payment.scheduleType)}
      </Table.Cell>
      <Table.Cell className="status">
        <PaymentStatusTag status={paymentDetails.status} />
      </Table.Cell>
      {advancedMode && <Table.Cell className="due" />}
      <Table.Cell className="amount payment">
        <Money
          amount={payment.amount}
          balance
          className={classNames({
            strikeThrough: paymentDetails.voided
          })}
        />
      </Table.Cell>
      <Table.Cell className="balance">
        <Money amount={payment.balance} balance />
      </Table.Cell>
      <Table.Cell className="mode" />
    </Table.Row>
  );
};

export default PaymentRow;
